export default "__VITE_ASSET__Byiwd4RT__"